import React from 'react';
import Tag from './Tag';
import './ProjectCard.css';

/**
 * Glassmorphic project tile with a gradient banner, tech tags
 * and an optional call-to-action link.
 *
 * @param {'violet' | 'cyan' | 'pink'} accent
 */
export default function ProjectCard({
  title,
  description,
  emoji = '✨',
  tech = [],
  link,
  linkLabel = 'View project →',
  accent = 'violet',
}) {
  return (
    <article className={`project-card project-card--${accent}`}>
      <div className="project-card__banner" aria-hidden="true">
        <span className="project-card__emoji">{emoji}</span>
      </div>
      <div className="project-card__body">
        <h3 className="project-card__title">{title}</h3>
        <p className="project-card__description">{description}</p>
        <div className="project-card__tech">
          {tech.map((item) => (
            <Tag key={item} accent={accent} size="sm">
              {item}
            </Tag>
          ))}
        </div>
        {link && (
          <a href={link} className="project-card__link">
            {linkLabel}
          </a>
        )}
      </div>
    </article>
  );
}
